<span class="sort" [ngClass]="{'sort-asc': direction === 'asc', 'sort-desc': direction === 'desc'}">
  {{ title }}
  <fa-icon [icon]="icons.sortAvailable" *ngIf="!direction"></fa-icon>
  <fa-icon [icon]="icons.sorted" *ngIf="direction" [rotate]="direction === 'asc' ? 0 : 180"></fa-icon>
</span>
